module.exports = __webpack_public_path__ + "media/nastepne-slowo.9d372b82.mp3";